var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60002 11.1989C5.59926 9.45357 6.14215 7.75137 7.15326 6.32879C8.16437 4.90621 9.59348 3.8339 11.242 3.26086C11.1782 2.8609 11.2019 2.45184 11.3115 2.06192C11.4211 1.672 11.6139 1.3105 11.8768 1.00235C12.1397 0.69421 12.4662 0.446762 12.834 0.277082C13.2018 0.107402 13.602 0.0195312 14.007 0.0195312C14.4121 0.0195312 14.8123 0.107402 15.18 0.277082C15.5478 0.446762 15.8744 0.69421 16.1373 1.00235C16.4001 1.3105 16.593 1.672 16.7026 2.06192C16.8122 2.45184 16.8359 2.8609 16.772 3.26086C18.418 3.83625 19.844 4.90956 20.8525 6.33194C21.861 7.75432 22.4018 9.45526 22.4 11.1989V19.5989L26.6 22.3989V23.7989H1.40002V22.3989L5.60002 19.5989V11.1989ZM16.8 25.1989C16.8 25.9415 16.505 26.6537 15.9799 27.1788C15.4548 27.7039 14.7426 27.9989 14 27.9989C13.2574 27.9989 12.5452 27.7039 12.0201 27.1788C11.495 26.6537 11.2 25.9415 11.2 25.1989H16.8Z",
    fill: "#2D2C79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.dd18a5b58a8408736f63b4f630e3c1f5.svg";
export { ForwardRef as ReactComponent };